"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetUploadIcon24Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.NetUploadIcon24Regular = forwardRef_1.forwardRef('NetUploadIcon24Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { d: "M5.748 8.06a.75.75 0 1 1-.996-1.12l5.255-4.672a3 3 0 0 1 3.986 0l5.255 4.671a.75.75 0 0 1-.996 1.122l-5.255-4.672a1.505 1.505 0 0 0-.247-.178V16.5a.75.75 0 0 1-1.5 0V3.211c-.086.05-.17.11-.246.178L5.748 8.061Z" }),
        react_1.default.createElement("path", { d: "M2.75 21a.75.75 0 0 1 .75-.75h17a.75.75 0 0 1 0 1.5h-17a.75.75 0 0 1-.75-.75Z" })));
});
